<template>
    <div class="content_mini_info">
        <div class="mini_info box_shadow flex">
            <div class="image_part">
                <div class="image">
                    <picture v-full-image-path:assets="'icon_info_lamp.svg'" />
                </div>
            </div>
            <div class="content_part">
                <div class="content" v-html="value.text" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
